export default function SectionDivider() {
  return (
    <div
      aria-hidden="true"
      className="bg-cyan-800/20 dark:bg-cyan-500 m-auto my-32 w-1 rounded-full h-20"
    ></div>
  );
}
